import React from 'react';
import { useState } from 'react';
import './classes/WhatIsSmww.css';
import { configData } from "../config";

// Sidebar "What is SMWW?" video: the cover picture is swapped for the video on click.
// Both files are on the live Drupal site.
const WhatIsSmww = () => {
    const files_url = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/';
    const [playVideo, setPlayVideo] = useState(false);

    return (
        <div className="what-is-smww">
            <h2>What is SMWW?</h2>
            {playVideo ? (
                <video src={files_url + 'KOIN.mp4'} controls autoPlay />
            ) : (
                <button type="button" className="what-is-smww__cover" onClick={() => setPlayVideo(true)} aria-label="Play video">
                    <img src={files_url + 'KOIN.png'} alt="What is SMWW?" />
                    <span className="what-is-smww__play" />
                </button>
            )}
        </div>
    );
};

export default WhatIsSmww;
